import GuidePage from "@/components/guide-page";

export default function GuideNewPetWelcomeKit() {
  return (
    <GuidePage
      eyebrow="Free Guide · Tallahassee Lassie"
      title="New Puppy & Rescue Welcome Kit"
      metaTitle="New Puppy & Rescue Welcome Kit (Tallahassee)"
      metaDescription="Bringing home a new puppy or rescue dog in Tallahassee? A first-two-weeks guide: supply checklist, the 3-3-3 decompression rule, house-training rhythm, vet setup, and local resources."
      path="/resources/new-pet-welcome-kit"
      heroImg="https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/864749a5-47e0-4938-ad8f-5b56b9ee2e2a/Lacy.jpeg"
      intro="Congratulations on your new family member! The first couple of weeks set the tone for everything that follows. Whether you've brought home a bouncy puppy or a rescue who's still figuring you out, here's how to make the transition calm, safe, and joyful — Tallahassee style."
      sections={[
        {
          heading: "Before they come home: the supply checklist",
          checklist: [
            "Food (ideally what they're already eating, to avoid tummy upset), bowls, and treats.",
            "Properly sized crate, bed, and a couple of safe chew toys.",
            "Collar, ID tag with your phone number, harness, and leash.",
            "Enzymatic cleaner for the inevitable accidents.",
            "Baby gates to limit roaming while they learn the house.",
            "A vet appointment booked for the first week.",
          ],
        },
        {
          heading: "The 3-3-3 rule for rescues",
          body: "Rescue dogs decompress on their own timeline. A helpful guide: in the first 3 days they may be overwhelmed, shut down, or unsure — give them space and quiet. By 3 weeks they start settling in, learning your routine, and showing their personality. Around 3 months they truly feel at home and bonded. Don't rush it; patience now pays off for years.",
        },
        {
          heading: "Set a house-training rhythm",
          body: "Puppies and newly-homed dogs do best with predictability. Take them out first thing in the morning, after meals, after naps, after play, and right before bed. Reward immediately when they go outside. Accidents are normal — clean thoroughly with an enzymatic cleaner so the spot doesn't become a repeat target, and never punish after the fact.",
        },
        {
          heading: "First-week Tallahassee to-do list",
          checklist: [
            "Schedule a wellness exam with a local vet and update microchip details.",
            "Get a Leon County pet license / rabies tag as required.",
            "Find your nearest emergency animal hospital and save the number.",
            "Locate a few shaded, low-traffic spots for those first short walks.",
            "Start a simple daily routine for feeding, potty, and rest.",
          ],
        },
        {
          heading: "Help them feel secure",
          checklist: [
            "Keep early days calm — hold off on big introductions and crowds.",
            "Use a crate or cozy corner as their safe retreat, never as punishment.",
            "Introduce new people and dogs slowly, on your dog's terms.",
            "Watch body language; let them approach rather than forcing interactions.",
          ],
        },
        {
          heading: "When to add a walker or sitter",
          body: "New dogs thrive on routine — and a midday break helps enormously when you're back at work, especially during house-training. Once your pup has settled and had their initial vet visit, a consistent walker can reinforce good habits and burn off energy. We're happy to start gently with a Meet & Greet so your dog gets to know us at their pace.",
        },
      ]}
      ctaHeading="Heading back to work with a new pup at home?"
      ctaBody="A consistent midday visit keeps house-training on track and your dog happy. Book a free call and we'll ease into a routine together."
    />
  );
}
